// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}
.success-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(to bottom, #8a2be2, #adff2f);
  color: white;
  font-family: Arial, sans-serif;
}
.success-screen .green-button {
  width: 50%;
}

.purchase {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  font-size: 16px;
  font-family: GteDisplayLight;
}

.success-icon {
  margin: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.success-icon.pending {
  width: 100px;
  height: 100px;
  border: 10px solid rgba(255, 255, 255, 0.3);
  border-top: 10px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.checkmark-circle {
  width: 100px;
  height: 100px;
  background-color: #00ff00;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkmark {
  font-size: 50px;
  color: #fff;
}

.success-text {
  font-size: 36px;
  font-weight: bold;
  font-family: GteDisplayBold;
}

.subtitle {
  margin: 20px 0;
  font-size: 18px;
  font-family: GteDisplayBold;
}

.done-button {
  padding: 10px 40px;
  background-color: #adff2f;
  border: none;
  border-radius: 20px;
  font-size: 18px;
  color: #000;
  cursor: pointer;
  margin-bottom: 20px;
  font-family: GteDisplayBold;
}

.done-button:hover {
  background-color: #9eff2f;
}`, "",{"version":3,"sources":["webpack://./src/pages/successPayment/successWindow.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,kBAAA;EACA,+DAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,wDAAA;EACA,YAAA;EACA,8BAAA;AAAF;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AADF;;AAIA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACE,YAAA;EACA,aAAA;EACA,2CAAA;EACA,2BAAA;EACA,kBAAA;EACA,kCAAA;AADJ;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,WAAA;AAHF;;AAMA;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,cAAA;EACA,eAAA;EACA,2BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,yBAAA;AAHF","sourcesContent":["@font-face {\r\n  font-family: 'GteDisplayBold';\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format('truetype');\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: 'GteDisplayExtra';\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format('truetype');\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: 'GteDisplayLight';\r\n  font-style: normal;\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format('truetype');\r\n  font-weight: normal;\r\n}\r\n\r\n.success-screen {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh;\r\n  background: linear-gradient(to bottom, #8a2be2, #adff2f);\r\n  color: white;\r\n  font-family: Arial, sans-serif;\r\n\r\n  .green-button {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n.purchase {\r\n  margin-top: 20px;\r\n  padding: 10px 20px;\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-radius: 20px;\r\n  font-size: 16px;\r\n  font-family: GteDisplayLight;\r\n}\r\n\r\n.success-icon {\r\n  margin: 40px 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  &.pending {\r\n    width: 100px;\r\n    height: 100px;\r\n    border: 10px solid rgba(255, 255, 255, 0.3);\r\n    border-top: 10px solid #fff;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.checkmark-circle {\r\n  width: 100px;\r\n  height: 100px;\r\n  background-color: #00ff00;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.checkmark {\r\n  font-size: 50px;\r\n  color: #fff;\r\n}\r\n\r\n.success-text {\r\n  font-size: 36px;\r\n  font-weight: bold;\r\n  font-family: GteDisplayBold;\r\n}\r\n\r\n.subtitle {\r\n  margin: 20px 0;\r\n  font-size: 18px;\r\n  font-family: GteDisplayBold;\r\n}\r\n\r\n.done-button {\r\n  padding: 10px 40px;\r\n  background-color: #adff2f;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 18px;\r\n  color: #000;\r\n  cursor: pointer;\r\n  margin-bottom: 20px;\r\n  font-family: GteDisplayBold;\r\n}\r\n\r\n.done-button:hover {\r\n  background-color: #9eff2f;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
